import { Vue, Component, Prop } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';
import { isAPICatchError, isEmptyValue, sortByProperty } from '@/utils/utils';
import { groupsApi } from '@/providers/apis/groups/groups';
import { copy } from '@/utils/cohort';
import AclSelect from '@/components/acl-select/acl-select';
import SlidePopupLayout from '@/components/cards/slide-popup-layout/slide-popup-layout';
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';
import { rosterAPI } from '@/providers/apis/roster/roster';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';


@Component({
    name: 'add-class-to-school-page',
    components: {
        'slide-pullup': SlidePopupLayout,
        'acl-select': AclSelect,
        'date-range-picker': DateRangePicker,
    },
})

export default class AssignSchool extends Vue {

    private dateRange: any = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: new Date(),
    };

    private fieldsItems: any[] = [
        {
            key: 'id',
            label: 'Sl.No',
            thClass: 'sticky-position',
            tdClass: 'align-baseline',
            allowFilter: false,
        },
        {
            key: 'title',
            label: 'Class Name',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'class_code',
            label: 'Class Code',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'class_created_date',
            label: 'Class Created At',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'teacher.username',
            label: 'Teacher Username',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'teacher.email',
            label: 'Teacher Email',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'assignSchool',
            label: 'Assign School',
            thClass: 'sticky-position',
            tdClass: 'align-baseline',
            allowFilter: false,
        },
    ];

    private classesList: any[] = [];

    private isShowDateFilter: boolean = false;

    private isLoading: boolean = false;

    private cohortLevel: any = [];

    private removeFromHierarchy: any = ['class'];

    private selectionALCs: any = {};

    private selectionALCsList: any = {};

    private isAclSelectionGrid: any = true;

    private isSubmitted: boolean = false;

    private selectedClassData: any = {};

    private currentPage: number = 1;

    private offset: number = 0;

    private limit: number = 10;

    private totalRowCounts: number = 1;

    private searchTerms: any = {};

    private searchItem: any = {};

    private isSearched: any = false;


    // -----------------------------------------------------------------------
    // Hooks

    private created() {
        this.fetchUserACL();
        this.getClassesList();
    }


    private hideSchoolModal() {
        this.$bvModal.hide('assign-school');
    }

    private fetchUserACL() {
        groupsApi.fetchUserHierarchies().then((hierarchy: any) => {
            for (const iterator of this.removeFromHierarchy) {
                hierarchy[0].levels = hierarchy[0].levels.filter((item: any) => {
                    return item.type !== iterator;
                });
            }
            sortByProperty(hierarchy[0].levels, 'sequence', 'ASC');
            this.cohortLevel = hierarchy[0].levels;
            this.fetchCohortListAll();
        });
    }

    private async fetchCohortListAll() {
        this.isLoading = true;
        const levels: any = copy(this.cohortLevel);
        for await (const [index, iterator] of levels.entries()) {
            iterator.child = {};
            iterator.child = await groupsApi.fetchGroupedHierarchyMapping({ type: iterator.type });
            this.selectionALCs[iterator.sequence] = '';
            if (iterator.sequence === 1) {
                this.selectionALCsList[iterator.sequence] = iterator.child[0].cohortList;
                this.selectionALCs[iterator.sequence] = 0;
            }
            if (index === levels.length - 1) {
                this.isLoading = false;
                this.cohortLevel = levels;
            }
        }
    }

    private onSelectListItem(type: any, selectedId: any, index: any) {
        const selected = this.cohortLevel[index + 1];
        this.$set(this.selectionALCs, this.cohortLevel[index].sequence, selectedId);
        if (selected && selected.sequence) {
            this.$set(this.selectionALCsList, selected.sequence, selected.child[selectedId].cohortList);
        }
    }

    private showAddSchoolPopup(data: any) {
        for (const iterator of this.cohortLevel) {
            this.selectionALCs[iterator.sequence] = '';
        }
        this.selectedClassData = data;
        this.isSubmitted = false;
        this.$bvModal.show('assign-school');
    }

    private onSelectPage(pageNumber: number) {
        this.classesList = [];
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.getClassesList();
    }

    private showDateFilter() {
        this.isShowDateFilter = true;
        setTimeout(() => {
            const datePick: any = this.$refs.picker as HTMLElement;
            if (datePick) {
                datePick[0].togglePicker(true);
            }
        }, 200);
    }

    private updateValues() {
        this.offset = 0;
        const dataRange = copy(this.dateRange);
        this.searchTerms.classCreatedDate = `${moment(dataRange.startDate).format('YYYY-MM-DD')}`;
        this.onSearch();
    }

    private removeDateFilter() {
        this.isShowDateFilter = false;
        this.dateRange = {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: new Date(),
        };
        this.searchTerms.classCreatedDate = '';
        this.onSearch();
    }

    private dateFormat(classes: any, date: any) {
        if (!classes.disabled) {
            const a = moment(date.getTime()).format('DD MMM YYYY');
            const b = new Date();
            classes.disabled = moment(a).isAfter(b);
        }
        return classes;
    }

    private searchTable(searchText: any, searchKey: any) {
        if (searchText.length >= 3 || isEmptyValue(searchText)) {
            switch (searchKey) {
                case 'title':
                    this.searchTerms.title = searchText;
                    break;
                case 'class_code':
                    this.searchTerms.code = searchText;
                    break;
                case 'teacher.username':
                    this.searchTerms.teacherUserName = searchText;
                    break;
                case 'teacher.email':
                    this.searchTerms.teacherEmail = searchText;
                    break;
                default:
                    break;
            }
            const that = this;
            if (!that.isSearched) {
                that.isSearched = true;
                setTimeout(() => {
                    that.isSearched = false;
                    that.onSearch();
                }, 1000);
            }
        }
    }

    private removeDate(searchText: any, searchKey: any) {
        switch (searchKey) {
            case 'title':
                this.searchTerms.title = '';
                this.searchItem.title = '';
                break;
            case 'class_code':
                this.searchTerms.code = '';
                this.searchItem.class_code = '';
                break;
            case 'teacher.username':
                this.searchTerms.teacherUserName = '';
                this.searchItem.teacher.username = '';
                break;
            case 'teacher.email':
                this.searchTerms.teacherEmail = '';
                this.searchItem.teacher.email = '';
                break;
            default:
                break;
        }
        this.onSearch();
    }

    private onSearch() {
        this.resetProperties();
        this.getClassesList();
    }

    private resetProperties() {
        this.classesList = [];
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
    }

    private getClassesList() {
        this.isLoading = true;
        const offset = this.offset;
        const limit = this.limit;
        const searchTerms = this.searchTerms;
        const params: any = {
            offset,
            limit,
        };
        for (const key in searchTerms) {
            if (Object.prototype.hasOwnProperty.call(searchTerms, key)) {
                const element = searchTerms[key];
                if (!isEmptyValue(element)) {
                    params[key] = element;
                }
            }
        }
        adminUtilsAPI.getClassDetails(params).then((data) => {
            this.classesList = [];
            this.isLoading = false;
            if (!isAPICatchError(data)) {
                this.classesList = data.classes;
                this.totalRowCounts = data.total;
            }
        });

    }
    private onAssignSchool() {
        this.isSubmitted = true;
        this.$validator.validate().then((valid) => {
            if (valid) {
                const classID = this.selectedClassData.class_id;
                const coho = this.cohortLevel[this.cohortLevel.length - 1];
                const groupId = this.selectionALCs[coho.sequence];
                adminUtilsAPI.updateClassGroup(groupId, classID).then((data) => {
                   if (!isAPICatchError(data)) {
                       this.getClassesList();
                       this.hideSchoolModal();
                   }
               });
            }
        });
    }

}
